<template>
  <div class="jmk-home literature-sec">
    <sbanner />

    <div class="container">
      <sub-cate :cateList="colums" :curIndex="cateIndex" @clickChange="changeCate"
        v-if="colums && colums.length"></sub-cate>

      <SmallCate name='分类标签' isSingle :list="cateType" @change="changeSmallLabel" />

      <div class="program-list">
        <div class="list-select">
          <div class="list-select-part part2">
            <template v-for="item in selectCondition">
              <select-pop-btn :selectCondition="item" @clickItem="selectConditonChoose" />
            </template>
          </div>
        </div>

        <div class="lists ">
          <empty v-if="empty">
            <template v-slot:emptyTips>
              <div class="empty-txt">没有更多了</div>
            </template>
          </empty>
          <loading v-show="showLoading" />
          <!-- 小说列表 -->
          <div class="literature-book" v-if="curCate == 1">
            <template v-if="programList && programList.length > 0">
              <book-item-2 :item="item" v-for="(item, index) in programList" :key="index" />
            </template>

          </div>

          <!-- 散文列表 -->
          <div class="literature-tabel" v-else>
            <card-table :list="programList" :category="cateid" newWindow v-if="programList && programList.length > 0" />
          </div>


        </div>

        <!-- 分页器 -->
        <Pagination :total="listTotal" :curPage="pageIndex" :pageSize="pageSize" @clickPage="clickPage"
          v-if="listTotal > 0" />
      </div>
    </div>
  </div>
</template>

<script>
import sbanner from '@/components/sbanner.vue'
import SubCate from '@/components/sub-cate.vue'
import colums from '@/colums/colums.js'
import area from '@/config/area.js';
import SmallCate from '@/components/small-cate.vue'
import SelectPopBtn from '@/components/common/selectPopBtn.vue'
import BookItem2 from './components/BookItem2.vue';
import Loading from '@/components/common/loading.vue'
import Pagination from '@/components/pagination.vue';
import CardTable from './components/CardTable.vue';
import Empty from '@/components/common/empty.vue';
export default {
  components: {
    sbanner,
    SubCate,
    SmallCate,
    SelectPopBtn,
    BookItem2,
    Loading,
    Pagination,
    CardTable,
    Empty
  },
  name: 'literature-sec',
  props: {},
  data() {
    return {
      colums: colums.literatureCate,
      cateIndex: 0,
      cateType: [],
      selectCondition: [
        {
          type: 'year',
          defaultName: '全部年份',
          dropList: []
        },
        {
          type: 'area',
          defaultName: '全部地区',
          dropList: area.gdData2
        },
        {
          type: 'award',
          defaultName: '全部获奖情况',
          dropList: ['全部获奖情况', '是', '否']
        }
      ],
      empty: false,
      showLoading: false,
      pageIndex: 1,
      listTotal: 0,
      pageSize: 18,
      programList: [],
      filterCondition: [], //筛选条件结果
      allFilter: {
        subtype_id: "", //节目分类
        prgoramForm: "", //节目形式
        showType: "", //展示类型-视频图片
        task_year: "", //年份
        city: "", //城市
        is_award: -1, //获奖情况 1获奖，0不获奖
        is_check: -1,
        is_top: -1,
        recommend: -1,
      },
      subId: '',
    }
  },
  computed: {
    curCate() {
      return this.$route.query.cate;
    }
  },
  mounted() {
    const { cate, subId } = this.$route.query
    this.cateid = cate
    this.subId = subId

    this.initPage()
  },
  methods: {
    async initPage() {
      this.getYearSelect(); //获取筛选年份
      await this.getCateType(this.cateid);
      this.getList();
      this.$api.recordApi.addListRecord('文学', this.cateid);
    },

    // 分类
    async getCateType(cateid) {
      this.cateIndex = this.colums.findIndex(t => t.id == cateid)
      // let obj = this.colums.find(t => {
      //   return t.id == cateid;
      // });
      // let params = {
      //   parentId: obj.labelid
      // };
      // let list = await this.$api.channelApi.getChannel(params);
      // list = list.data;
      // list = list.map(item => {
      //   return {
      //     ...item,
      //     focused: item.id == this.subId
      //   }
      // })

      const res = await this.$api.literatureApi.getCateList()
      let list = res[`data${cateid}`] || []
      list = list.map(v => {
        return {
          ...v,
          focused: v.id == this.subId
        }
      })
      //匹配当前选中项
      this.cateType = [{ id: '', name: '全部', focused: !this.subId }, ...list];
    },

    //获取筛选的年份
    async getYearSelect() {
      let params = {
        categoryid: 3,
        typeid: this.allFilter.subtype_id.id || -1
      };
      let minYearObj = await this.$api.yearApi.getMinYear(params);
      let minYear = parseInt(minYearObj.data);
      let yearScode = this.$utils.getBetweenYear(minYear);
      yearScode.unshift("全部年份");
      this.selectCondition[0] = {
        type: "year",
        defaultName: "全部年份",
        dropList: yearScode
      };
    },

    changeCate({ id }) {
      if (id) {
        this.$router.push({
          path: '/literature',
          query: {
            cate: id
          }
        })
      }
    },

    //下拉选择返回数据
    selectConditonChoose(info) {
      // console.log(info);
      let item = info.subItem.toString().indexOf('全部') != -1 ? "" : info.subItem;
      switch (info.type) {
        case "year": this.allFilter['task_year'] = item; break;
        case "area": this.allFilter["city"] = item; break;
        case "award":
          item = item == '是' ? 1 : item == '否' ? 0 : -1;
          this.allFilter["is_award"] = item;
          break;
      }
      setTimeout(() => {
        this.pageIndex = 1;
        this.getList()
      }, 100);

    },

    changeSmallLabel() {
      this.pageIndex = 1
      this.programList = []
      this.getList()
    },

    async getList() {
      this.showLoading = true;
      this.empty = false;
      if (this.pageIndex == 1) {
        this.programList = []
      }
      // this.programList = [];
      let type_tag = "",
        arr = [];
      this.cateType.forEach(item => {
        if (item.subType) {
          item.subType.map(t => {
            t.focused && arr.push(t.id);
          });
        } else {
          item.focused && arr.push(item.id);
        }
      });
      type_tag = arr.join(",");
      let params = {
        page: this.pageIndex,
        pageSize: this.pageSize,
        category: this.cateid, //节目分类id,2,4,6,8,10
        type_tag: type_tag || "", //分类标签
        is_award: this.allFilter.is_award, //是否获奖 1，-1
        city: this.allFilter.city || "", // 城市
        task_year: this.allFilter.task_year || "", //年限
        is_check: this.allFilter.is_check,
        is_top: this.allFilter.is_top,
        recommend: this.allFilter.recommend
      };
      type_tag && (params.typeid = type_tag)
      const res = await this.$api.literatureApi.getList(params)
      let list = res.data || []
      list = await Promise.all(
        list.map(async (v) => {
          return {
            ...v,
            cover_img: this.setImage(res.showpath, v.cover_img, `?x-oss-process=image/resize,m_lfit,w_400`),
            thumbs: v.cover_img ? res.showpath + v.cover_img : ''
          };
        })
      );
      // test image menu
      const programList = list.map((v, i) => {
        v.index = i
        if (v.type_id && !v.type_name) {
          let obj = this.cateType.find(vv => { return vv.id == v.type_id })
          obj && (v.type_name = obj.name)
        }
        return {
          ...v,
          author: this.$utils.fixedAuthor(v.listasv)
        }
      });

      this.programList = [...programList];

      if (this.programList.length == 0) { this.empty = true }
      this.listTotal = res.total;
      const totalPage = Math.ceil(res.total / this.pageSize)
      this.hasNextPage = totalPage > this.pageIndex;
      this.showLoading = false;
    },

    //跳转分页
    clickPage(info) {
      if (info.topage > 0) {
        this.pageIndex = info.topage;
        this.getList()
      }
    },
  },
}
</script>
<style scoped lang="scss"></style>